module.exports = {
    common: {
        no_access: '您没有访问权限'
    },
    ChanceBoard: {
        department: '部門',
        sales_user_id: '銷售員',
        query: '查詢',
        Show_chance_distribution: '顯示機會分布',
        Show_sales_funnel: '顯示漏鬥數據',
        chance_cnt: '機會數量',
        win_amount: '成單金額',
        win_number: '成單數',
        fail_number: '失敗數',
        level_rise: '級別上升',
        level_decline: '級別下降',
        follow_number: '跟進客戶',
        create_chance: '創建機會',
        created_in_30_days: '30日創建',
        no_follow_in_30_days: '30日未跟進',
        no_follow_in_60_days: '60日未跟進',
        no_level_up_30_days: '30日無提升',
        has_quote_in_30_days: '30日有報價',
        has_contract_in_30_days: '30日有合同',
    },
    quote: {
        select_contacts: '選擇聯系人',
        select_quotation_template: '選擇報價模板',
        preview_template: '預覽模板',
        add_line: '添加商品行',
        trade_name: '商品名稱',
        unit: '單位',
        standard_price: '標準價',
        minimum_price: '最低價',
        tax_rate: '稅率',
        sales_price: '銷售價',
        discount_ratio: '折扣比例',
        number: '數量',
        remark: '備註',
        select_item: '選擇商品名稱',
        quote_remark: '報價備註',
        tax_amount: '稅額',
        total_amount_including_tax: '含稅總金額',
        template_extension_variable: '模板擴展變量',
        please_select: '請選擇',
        submit: '提交',
        price_tips: '當前價格低於最低價，需審核',
        template_preview: '模板預覽',
        template_tips: '請選擇模板',
        get_failed: '獲取失敗',
        failed_to_get_product_catalog: '獲取產品目錄失敗',
        contact_cannot_be_empty: '聯系人不能為空',
        quotation_template_cannot_be_empty: '報價模板不能為空',
        quotation_data_cannot_be_empty: '報價數據不能為空',
        submission_failed: '提交失敗',
        submitted_successfully: '提交成功',
    }
}